export default function () {
  const $expandBtn = $('.product__btn-expand');
  $expandBtn.on('click', function () {
    $(this).toggleClass('product__btn-expand--opened').parent().siblings().find('.product__btn-expand').removeClass('product__btn-expand--opened');
  });
}
